import React, { useState, useEffect } from 'react';
import { getAppraisalCount } from '../api.js';

const AppraisalCounter = () => {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Function to update the count
    const updateCount = async () => {
      try {
        const newCount = await getAppraisalCount();
        setCount(newCount);
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch appraisal count:', error);
        setLoading(false);
      }
    };

    // Initial fetch
    updateCount();

    // Set up periodic updates every 30 seconds
    const interval = setInterval(updateCount, 150000);

    // Cleanup on unmount
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-800 text-white rounded-lg p-4 mb-4">
        <div className="text-sm">Loading counter...</div>
      </div>
    );
  }

  return (
    <div className="total-appraisals-card">
      <div className="total-apprase-text">Total Appraisals</div>
      <div className="total-apprase-number">{count.toLocaleString()}</div>
    </div>
  );
};

export default AppraisalCounter;